import { default as indexYw9ncv1e9JMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/index.vue?macro=true";
import { default as infoSG8W2qHyNwMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/info.vue?macro=true";
import { default as _91challengeId_93u7Ae9pJCkXMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/promoter/[contentVersionId]/[challengeId].vue?macro=true";
import { default as registrationtNKZZRKJ7ZMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/registration.vue?macro=true";
import { default as _91batchId_93vZmVi1wbUkMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/results/[batchId].vue?macro=true";
import { default as _91groupId_93Cg2j3MP0XNMeta } from "/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/video/[groupId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/info.vue").then(m => m.default || m)
  },
  {
    name: "static-promoter-contentVersionId-challengeId",
    path: "/static/promoter/:contentVersionId()/:challengeId()",
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/promoter/[contentVersionId]/[challengeId].vue").then(m => m.default || m)
  },
  {
    name: "static-registration",
    path: "/static/registration",
    meta: registrationtNKZZRKJ7ZMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/registration.vue").then(m => m.default || m)
  },
  {
    name: "static-results-batchId",
    path: "/static/results/:batchId()",
    meta: _91batchId_93vZmVi1wbUkMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/results/[batchId].vue").then(m => m.default || m)
  },
  {
    name: "static-video-groupId",
    path: "/static/video/:groupId()",
    meta: _91groupId_93Cg2j3MP0XNMeta || {},
    component: () => import("/home/runner/work/wdd/wdd/frontend/postfinance/pages/static/video/[groupId].vue").then(m => m.default || m)
  }
]